import { useLazyQuery } from '@apollo/client';
import { useCallback, useMemo } from 'react';

import GetLatestFieldVerificationsQuery from '@/graphql/contracts/getLatestFieldVerifications.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetLatestFieldVerifications,
  GetLatestFieldVerificationsVariables
} from '@/graphql/contracts/_generated_/getLatestFieldVerifications.query';
import { EntityTypeEnum, FieldVerificationTypeEnum } from '@/graphql/contracts/_generated_/contracts';

export type FieldVerificationMap = Record<string,
{ userID: string; verifiedAt: string; type: FieldVerificationTypeEnum }
>;

export function useGetLatestFieldVerifications() {
  const [_getLatestFieldVerifications, { data, loading }] = useLazyQuery<
  GetLatestFieldVerifications,
  GetLatestFieldVerificationsVariables
  >(
    GetLatestFieldVerificationsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
    }
  );

  const getLatestFieldVerifications = useCallback((entityID: string) => {
    _getLatestFieldVerifications({
      variables: {
        entityID,
        entityType: EntityTypeEnum.CONTRACT,
      }
    });
  }, [_getLatestFieldVerifications]);

  const fieldVerificationMap = useMemo(() => {
    const map: FieldVerificationMap = {};
    if (data?.latestFieldVerifications) {
      data.latestFieldVerifications.forEach((v) => {
        if (v.type === FieldVerificationTypeEnum.REMOVED) return;
        map[v.field] = {
          userID: v.userID,
          verifiedAt: v.verifiedAt,
          type: v.type,
        };
      });
    }
    return map;
  }, [data]);

  return {
    getLatestFieldVerifications,
    fieldVerificationMap,
    isLoading: loading,
  } as const;
}
